import React from 'react'
import { Droppable } from 'react-beautiful-dnd';

import './CardsList.css'

import Card from './Card'

const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? 'rgba(255, 182, 236, 0.4)' : 'transparent'
});

const CardsList = (props) =>
<Droppable droppableId={props.id.toString()}>
  {(provided, snapshot) => (
    <div
      ref={provided.innerRef}
      className="cards-list"
      style={getListStyle(snapshot.isDraggingOver)}
    >
      {props.items.map((item, index) => (
        <Card key={index} {...item} index={index}/>
      ))}
      {props.items.length === 0 && <div className="drop-zone-message">Drop Here</div>}
      {provided.placeholder}
    </div>
  )}
</Droppable>

export default CardsList



// WEBPACK FOOTER //
// ./src/components/CardsList.js